<template>
	<div class="form-card">
		<div class="form-card-forms">
			<div class="row">
				<div class="col-lg-12">
					<div class="form-group mb-3">
						<label> Promotion </label>
						<div>
							<select class="form-control classic" name="WUPromotionType" v-model="vModel.WUPromotionType" :class="{'input': true, 'is-danger': errors.has('WUPromotionType') }">
								<option :value="null">Please Select Promotion</option>
								<option :key="item.Id" v-for="item in WuPromotionTypeCollection" :value="item.Id">
									{{item.Text}}
								</option>
							</select>

						</div>
					</div>
					<!-- eo form group -->
				</div>
				<div class="col-lg-6" v-if="vModel.WUPromotionType == 1">
					<div class="form-group">
						<label> Enter the marking promotion no. </label>
						<div class="mb-3">
							<input type="text" class="form-control" name="WUMarketingPromotionCode" v-only-text-number="" autocomplete="off"
							 v-model="vModel.WUMarketingPromotionCode" data-vv-as='Marketing Promotion' v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('WUMarketingPromotionCode') }" v-only-uppercase/>
							<div v-show="errors.has('WUMarketingPromotionCode')" class="help is-danger">
								{{ errors.first('WUMarketingPromotionCode') }}
							</div>
						</div>
					</div>
					<!-- eo form group -->
				</div>
				<div class="col-lg-12" v-if="vModel.WUPromotionType == 2">

					<div class="row">
						<div class="col-lg-6">
							<div class="form-group">
								<label for="">
									Western Union Number:
								</label>

								<div class="input-group mb-3">
									<input type="text" id="WUNumber" name="WUNumber" :disabled="true" autocomplete="off" placeholder="WU Number"
									 v-model="vModel.WUNumber" data-vv-as='WU Number' :class="{'input': true, 'is-danger': errors.has('WUNumber') ,'form-control' : true}" v-only-uppercase/>

									<div class="input-group-append">
										<button class="btn btn-red-outline-secondary" type="button" id="button-addon2" :disabled="!vModel.WUNumber"
										 @click="validateWUNumber">Verify</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-lg-6">
							<div class="form-group">
								<label>Loyal Points </label>
								<div class="mb-3">
									<input type="text " class="form-control text-uppercase" name="LoyalPoints" autocomplete="off" v-model="vModel.LoyalPoints"
									 :disabled="true" :class="{'input': true }" />
								</div>
							</div>
						</div>
						<div class="col-lg-6">
							<div class="form-group">
								<label> Promo Code Available </label>
								<div class="mb-3">
									<input type="text" class="form-control text-uppercase" name="WUKycPromotionCode" autocomplete="off" v-model="vModel.PromotionCode"
									 :disabled="true" :class="{'input': true }" v-only-uppercase/>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-lg-12">
							<label class="float-right">Use Promo Code:
								<!-- <bootstrap-toggle v-model="vModel.IsPromoCodeUsed" :options="{ on: 'YEs', off: 'NO' }" :disabled="!vModel.PromotionCode" /> -->

								<span>
									<b-form-radio-group v-model="vModel.IsPromoCodeUsed" :options="[{ text: 'YES', value: true }, { text: 'NO', value: false }]"
									 plain name="IsPromoCodeUsed" :disabled="!vModel.PromotionCode" /> </span>

							</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>
<script>
	export default {
		name: 'WUPromotion',
		inject: ['$validator'],
		props: ['vModel', 'WuPromotionTypeCollection'],
		methods: {
			onPromotionChange() {
				setTimeOut(() => {
					if (this.vModel.WUPromotionType != 1) {
						this.vModel.WUMarketingPromotionCode = "";
					}
				}, 100);
			},

			validateWUNumber: function () {
				var req = {
					WUNumber: this.vModel.WUNumber
				};

				if (this.vModel.WUNumber) {
					this.$http.post("westernunion/promocode/wucardnumber", req).then(res => {
						debugger;
						this.vModel.PromotionCode = res.body.PromotionCode;
						this.vModel.LoyalPoints = res.body.LoyalPoints;
					});
				}
			}
		}
	}
</script>
